module.exports = __webpack_public_path__ + "img/susanImg5@2x.0eb76c30.jpg";